import { render, staticRenderFns } from "./DetalleOrdenCaja.vue?vue&type=template&id=7f22be3c&scoped=true&"
import script from "./DetalleOrdenCaja.vue?vue&type=script&lang=js&"
export * from "./DetalleOrdenCaja.vue?vue&type=script&lang=js&"
import style0 from "./DetalleOrdenCaja.vue?vue&type=style&index=0&id=7f22be3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22be3c",
  null
  
)

export default component.exports